<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        span
            | {{ $i18n.t('presentations.presentations_form_name')}}:
            | {{ settings.presentation.name }}
        br
        slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
